/**
 * ADA Compliance Fix: Shop pay SVG alt and aria-label definition
 * Targets: .shopify-payment-button__button--shop-pay
 */


(function() {
    const applyAccessibilityFixes = () => {
      // 1. Target the Shop Pay Button
      const shopPayButton = document.querySelector('.shopify-payment-button__button--shop-pay');
      if (shopPayButton) {
        shopPayButton.setAttribute('aria-label', 'Pay with Shop Pay');
        
        // Ensure SVGs inside are accessible
        const shopPaySvgs = shopPayButton.querySelectorAll('svg');
        shopPaySvgs.forEach(svg => {
          if (!svg.getAttribute('aria-label')) {
            svg.setAttribute('role', 'img');
            svg.setAttribute('aria-label', 'Shop Pay Logo');
          }
        });
      }

      // 2. Target your specific purple icon/element
      // This looks for any element with BOTH classes
      const purpleIcons = document.querySelectorAll('.size-8.text-purple-primary');
      purpleIcons.forEach(icon => {
        // We only add the label if it doesn't already have one
        if (!icon.hasAttribute('aria-label')) {
          icon.setAttribute('aria-label', 'Icon description'); 
          // Note: Change 'Icon description' to whatever the icon actually represents (e.g., "Size Guide")
          
          // If it's an SVG, make sure it's not hidden from screen readers
          if (icon.tagName.toLowerCase() === 'svg') {
            icon.setAttribute('role', 'img');
            icon.setAttribute('aria-hidden', 'false');
          }
        }
      });
    };

    // Initialize the observer to catch elements as they load
    const observer = new MutationObserver((mutations) => {
      applyAccessibilityFixes();
    });

    // Start observing
    observer.observe(document.body, { 
      childList: true, 
      subtree: true 
    });

    // Run once on initial load just in case elements are already there
    applyAccessibilityFixes();
  })();


/**
 * ADA Compliance Fix: Convert Tooltip Divs to Buttons & Add Aria-Labels
 * Targets: .boost-sd__tooltip-content
 */

(function() {
  const upgradeBoostTooltips = () => {
    const tooltipDivs = document.querySelectorAll('.boost-sd__tooltip-content:not([data-ada-fixed])');

    tooltipDivs.forEach((oldDiv) => {
      // 1. Create the new Button element
      const newButton = document.createElement('button');
      
      // 2. Copy all classes and existing attributes
      newButton.className = oldDiv.className;
      Array.from(oldDiv.attributes).forEach(attr => {
        newButton.setAttribute(attr.name, attr.value);
      });

      // 3. Set ADA specific attributes
      const tooltipText = oldDiv.innerText.trim() || "Change layout";
      newButton.setAttribute('aria-label', tooltipText);
      newButton.setAttribute('type', 'button'); // Prevent form submission
      newButton.setAttribute('data-ada-fixed', 'true'); // Prevent infinite loop

      // 4. Move the internal content (icons/text) to the new button
      while (oldDiv.firstChild) {
        newButton.appendChild(oldDiv.firstChild);
      }

      // 5. Swap the elements in the DOM
      if (oldDiv.parentNode) {
        oldDiv.parentNode.replaceChild(newButton, oldDiv);
      }
    });
  };

  // Run on Boost initial render
  window.addEventListener('boost-sd-rendered', upgradeBoostTooltips);

  // Use MutationObserver for tooltips that are dynamically injected on hover/interaction
  const observer = new MutationObserver((mutations) => {
    let shouldRun = false;
    mutations.forEach((mutation) => {
      if (mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === 1 && (node.classList?.contains('boost-sd__tooltip-content') || node.querySelector?.('.boost-sd__tooltip-content'))) {
            shouldRun = true;
          }
        });
      }
    });
    if (shouldRun) upgradeBoostTooltips();
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // Initial execution for static elements
  upgradeBoostTooltips();
})();



/**
 * ADA Fix: Manage Focus & ARIA Announcements for Boost Filters
 * Resolves WCAG 3.2.2 (On Input) by restoring focus to a checked filter
 * and announces the updated product count for screen readers.
 */


// This goes inside the 'Success' callback of your Add to Cart fetch
const statusRegion = document.getElementById('accessible-status-region');
if (statusRegion) {
  statusRegion.textContent = 'Item successfully added to your cart.';
}


(function() {
    let activeFilterIdentifier = null;
    let isFilterInteraction = false;

    // 1. Create a visually hidden ARIA live region (if it doesn't already exist from the previous fix)
    const getOrCreateLiveRegion = () => {
        let liveRegion = document.getElementById('boost-ada-filter-announcer');
        if (!liveRegion) {
            liveRegion = document.createElement('div');
            liveRegion.id = 'boost-ada-filter-announcer';
            liveRegion.setAttribute('aria-live', 'polite');
            liveRegion.setAttribute('aria-atomic', 'true');
            Object.assign(liveRegion.style, {
                position: 'absolute', width: '1px', height: '1px', padding: '0', 
                margin: '-1px', overflow: 'hidden', clip: 'rect(0, 0, 0, 0)', 
                whiteSpace: 'nowrap', border: '0'
            });
            document.body.appendChild(liveRegion);
        }
        return liveRegion;
    };

    // 2. Intercept clicks (this covers both mouse clicks and keyboard Enter/Space)
    document.addEventListener('click', function(event) {
        const filterButton = event.target.closest('.boost-sd__filter-option-item-button');
        
        if (filterButton) {
            isFilterInteraction = true;
            
            // Capture a unique identifier for the button. Boost's 'data-action' is perfect for this.
            // If it's missing, we fall back to the aria-label.
            const dataAction = filterButton.getAttribute('data-action');
            const ariaLabel = filterButton.getAttribute('aria-label');
            
            if (dataAction) {
                activeFilterIdentifier = `[data-action="${dataAction}"]`;
            } else if (ariaLabel) {
                activeFilterIdentifier = `[aria-label="${ariaLabel.replace(/"/g, '\\"')}"]`;
            }
        } else if (event.target.closest('.boost-sd__product-list')) {
            isFilterInteraction = false; // Reset if they clicked a product
        }
    }, true);

    // 3. Observe the filter sidebar for DOM updates
    const initializeFilterObserver = function() {
        // Target a stable wrapper around the filters. 
        const filterSidebar = document.querySelector('.boost-sd__filter-tree') || document.querySelector('.boost-sd__filter-block-wrapper');
        
        if (!filterSidebar) {
            setTimeout(initializeFilterObserver, 500); // Wait and retry if not loaded yet
            return;
        }

        const observer = new MutationObserver(function(mutations) {
            if (isFilterInteraction && activeFilterIdentifier) {
                // Check if the DOM changes included new nodes (meaning Boost finished re-rendering)
                const hasUpdates = mutations.some(m => m.addedNodes.length > 0);
                
                if (hasUpdates) {
                    setTimeout(() => {
                        // A. Restore Focus to the newly rendered filter checkbox
                        const restoredButton = document.querySelector(activeFilterIdentifier);
                        if (restoredButton) {
                            restoredButton.focus();
                            
                            // Optional: Prevent focus ring for mouse users, while retaining it for keyboard users
                            if (document.body.classList.contains('using-mouse')) {
                                restoredButton.style.outline = 'none';
                            }
                        }

                        // B. Announce the updated product count 
                        // Note: Adjust the selector '.boost-sd__product-count' if your theme uses a different class
                        const liveRegion = getOrCreateLiveRegion();
                        const countElement = document.querySelector('.boost-sd__product-count, .boost-sd__product-list-header-count'); 
                        
                        let announcement = "Products updated.";
                        if (countElement && countElement.textContent) {
                            announcement = `Filter applied. Showing ${countElement.textContent.trim()}.`;
                        }

                        // Briefly clear to force screen reader to read the new text
                        liveRegion.textContent = '';
                        setTimeout(() => { liveRegion.textContent = announcement; }, 50);

                        // C. Reset flags
                        activeFilterIdentifier = null;
                        isFilterInteraction = false;
                    }, 100); // 100ms delay ensures the browser has painted the new nodes
                }
            }
        });

        // Observe the entire sidebar for structural changes
        observer.observe(filterSidebar, { childList: true, subtree: true });
    };

    // 4. Start the observer on load
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initializeFilterObserver);
    } else {
        initializeFilterObserver();
    }
})();